export let HttpResponseActionTypes;
(function (HttpResponseActionTypes) {
  HttpResponseActionTypes["RetryEndpoint"] = "[Http] Retry Endpoint";
  HttpResponseActionTypes["RequestFetch"] = "[Http] Fetch";
  HttpResponseActionTypes["Success"] = "[Http] Success";
  HttpResponseActionTypes["Error"] = "[Http] Error";
  HttpResponseActionTypes["SubmitUnauthenticatedSurvey"] = "[Http] Submit Unauthenticated Survey";
  HttpResponseActionTypes["SetTimeStarted"] = "[Http] Set Time Started";
  HttpResponseActionTypes["SetTimeCompleted"] = "[Http] Set Time Completed";
})(HttpResponseActionTypes || (HttpResponseActionTypes = {}));